import { CategoryApiService } from '@/core';
import { CommonStatusValues } from '@/shared';
import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { CategoryEntity } from '@repo/types';

@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.scss',
})
export class CategoriesComponent {
  private readonly categoryApi = inject(CategoryApiService);

  table = table({
    itemsFn: this.categoryApi.getAdapter(),
    view: {
      itemName: 'Category',
    },
    columns: {
      id: { label: 'ID' },
      name: { label: 'Name' },
      'image.url': { label: 'Image', type: 'image' },
      'parent.name': { label: 'Parent' },
      priority: { label: 'Priority' },
      status: {
        label: 'Status',
        items: CommonStatusValues,
      },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item: CategoryEntity) => dialog$.category({ category: item }).afterSubmit(),
      },
      {
        type: 'icon',
        content: 'trash',
        action: (item) => dialog$.deletePrompt(true).action(() => this.categoryApi.deleteCategory(item.id)),
      },
    ],
    events: {
      add: () => dialog$.category().afterSubmit(),
    },
  });
}
